import Utils from 'utils/Utils';
import { SUPPORTED_STREAM } from 'constants.js';

export const getRecordedInfo = eventRecorded => {
  let url;
  const deviceSO = Utils.getDeviceOS();
  SUPPORTED_STREAM[deviceSO].forEach(value1 => {
    if (eventRecorded?.actions?.play[value1]) {
      url = eventRecorded?.actions?.play[value1];
    }
  });
  const recordedInfo = {
    item: eventRecorded?.channel?.event,
    url,
  };

  return recordedInfo;
};
